import { data, redirect } from "react-router";

/** Fetches JSON from the API, turning HTTP errors into route errors. */
export async function api<T>(path: string, init?: RequestInit): Promise<T> {
	const res = await fetch(path, {
		...init,
		credentials: "same-origin",
		headers: init?.body ? { "Content-Type": "application/json", ...init.headers } : init?.headers,
	});
	if (res.status === 401) throw redirect("/login");
	if (!res.ok) {
		const body = (await res.json().catch(() => null)) as { error?: string } | null;
		throw data(body?.error ?? res.statusText, { status: res.status });
	}
	return res.json() as Promise<T>;
}
